import { render, staticRenderFns } from "./Chanpin.vue?vue&type=template&id=36f77c9e&scoped=true&"
import script from "./Chanpin.vue?vue&type=script&lang=js&"
export * from "./Chanpin.vue?vue&type=script&lang=js&"
import style0 from "./Chanpin.vue?vue&type=style&index=0&id=36f77c9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f77c9e",
  null
  
)

export default component.exports